module.exports = __webpack_public_path__ + "img/zfcg.92996057.png";